// @flow
/* eslint-disable complexity */
/**
 * Get cookie value by name factory.
 * @param {String} cookies raw cookies
 * @returns {Function} function that returns value for passed cookie name.
 *
 */
export default (cookies: string) => (name: string) => {
    const cookieArr = cookies.split(';');
    while (cookieArr.length) {
        const cookie = cookieArr.pop();
        let separatorIndex = cookie.indexOf('=');
        separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
        const cookieName = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
        if (cookieName === name) {
            return decodeURIComponent(cookie.slice(separatorIndex + 1));
        }
    }
    return null;
};
